<template>
  <main>
    <div v-if="['EH', 'CLAY']?.includes(group)">
      <div v-html="ehSelectedSchool?.paymentInfo?.text" />
      <div>Beneficiary Name: {{ ehSelectedSchool.paymentInfo.Beneficial }}</div>
      <div>Bank Name: {{ ehSelectedSchool.paymentInfo?.bankName }}</div>
      <div v-if="ehSelectedSchool.paymentInfo?.bankBranch">Bank Branch / Bank Address : {{ ehSelectedSchool.paymentInfo?.bankBranch }}</div>
      <div>Swift Code: {{ ehSelectedSchool.paymentInfo?.swiftCode }}</div>
      <div>Bank Account : {{ ehSelectedSchool.paymentInfo?.bankAcc }}</div>
      <div>Bank / Branch Code: {{ ehSelectedSchool.paymentInfo?.branchCode }}</div>
      <div v-if="ehSelectedSchool.paymentInfo?.bankAddress">Bank Address: {{ ehSelectedSchool.paymentInfo?.bankAddress }}</div>
      <div><br /></div>
      <div>
        <strong
          >You can also click
          <a target="_blank" :href="ehSelectedSchool.paynowQrImage">here</a>
          to pay via PayNow QR Code.</strong
        >
        Please indicate your child’s full name under 'Reference No.'
      </div>
    </div>

    <div v-if="group === 'PRE'">
      <div>
        <strong>Bank Details (Wire Transfer)</strong>: <br />
        <small>{{ preSchoolInfo?.paymentInfo?.remarks }}</small>
      </div>
      <div class="mt-3">Beneficiary Name: {{ preSchoolInfo.paymentInfo?.Beneficial }}</div>
      <div>Bank Name: {{ preSchoolInfo.paymentInfo.bankName || `United Overseas Bank Limited` }}</div>
      <div>Swift Code: {{ preSchoolInfo.paymentInfo.bankCode || `UOVBSGSG` }}</div>
      <div>Bank Account : {{ preSchoolInfo.paymentInfo.bankAcc }}</div>
      <div>Bank / Branch Code: {{ preSchoolInfo.paymentInfo.branchCode }}</div>
      <div><br /></div>
      <div>
        <strong
          >You can also click
          <a target="_blank" :href="preSchoolInfo.paynowQrImage">here</a>
          to pay via PayNow QR Code.</strong
        >
        Please indicate your child’s full name under 'Reference No.'
      </div>
    </div>

    <div v-if="group === 'MIS'">
      <div><strong>Bank Details (Wire Transfer)</strong>: Bank Charges shall be borne by remitter.<br />{{ misPaymentReferenceText }}</div>
      <div>Beneficiary Name: Middleton International School Pte Ltd</div>
      <div>Bank Name: OVERSEA-CHINESE BANKING CORPORATION</div>
      <div>BIC Code: OCBCSGSG</div>
      <div>Account Name: Middleton International School Pte Ltd</div>
      <div>Account Number: 695-879973-001</div>
      <div><br /></div>
      <div>
        <strong>You can also click <a target="_blank" :href="paynowQrImage">here</a> to pay via PayNow QR Code.</strong><br />{{ misPaymentReferenceText }}
      </div>
    </div>
  </main>
</template>

<script>
import { schools, middletonSchools, ehSchoolsData } from '@/pages/application/data'

export default {
  props: ['group', 'school', 'preSchoolInfo'],
  data() {
    return {
      schools,
      middletonSchools,
      ehSelectedSchool: {},
    }
  },
  computed: {
    paynowQrImage() {
      switch (this.school) {
        case middletonSchools['Tampines']:
          return `https://kws.etonhouse.com/images/MIS_TP_QR_CODE.pdf`
        case middletonSchools['Upper Bukit Timah']:
          return `https://kws.etonhouse.com/images/MIS_215UBT_QR_CODE.pdf`
        default:
          return ''
      }
    },
    misPaymentReferenceText() {
      switch (this.school) {
        case middletonSchools['Tampines']:
          return `Please indicate ‘TP_ChildName’ under Reference/Comment. E.g. TP_JohnDoe`
        case middletonSchools['Upper Bukit Timah']:
          return `Please indicate ‘UA_Grade_YearJoining_ChildName’ under Reference/Comment. E.g. UA_G1_2023_JohnDoe`
        default:
          return ''
      }
    },
  },
  mounted() {
    if (this.group === 'EH') {
      let selectedSchool = Object.keys(this.schools).find(key => this.schools[key] === this.school)
      this.ehSelectedSchool = ehSchoolsData?.[selectedSchool]
    }
    if (this.group === 'CLAY') {
      this.ehSelectedSchool = ehSchoolsData?.Claymore
    }
  },
}
</script>

<style scoped>
main {
  margin-top: 0.5rem;
}

a {
  color: blue;
}
</style>
